import { render, staticRenderFns } from "./LinkBoardInvite.vue?vue&type=template&id=be9533a6&scoped=true&"
import script from "./LinkBoardInvite.vue?vue&type=script&lang=js&"
export * from "./LinkBoardInvite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be9533a6",
  null
  
)

export default component.exports